import React, {useEffect, useState, useMemo} from "react";
import styled from "styled-components/macro";

import {
    Box,
    Card as MuiCard,
    CardContent as MuiCardContent, Checkbox,
    Divider as MuiDivider, FormControlLabel,
    Typography as MuiTypography,
} from "@material-ui/core";


import { spacing } from "@material-ui/system";
import {withStyles, makeStyles} from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";

const Card = styled(MuiCard)(spacing);

const Typography = styled(MuiTypography)(spacing);

const CardContent = styled(MuiCardContent)`
  position: relative;
  background-color: ${(props) => props.theme.palette.background.paper};
`;


const ColouredTypography = styled(Typography)`
  color: ${(props) => props.color ? props.color : props.theme.sidebar.background};
  font-size: ${(props) => props.size ? props.size : "default"};
`

const ColouredCard = styled(Card)`
  background-color: ${(props) => props.color ? props.color : props.theme.sidebar.background};
  padding: 10px 10px 10px 10px;
  height: 100%;
  border-radius: 10px 0px 0px 10px;
`

const useCheckBoxStyles = makeStyles({
    root: {
        '&.MuiCheckbox-root': {
            color: (props) => props.color,
        },
        '&.Mui-checked': {
            color: (props) => props.color,
        },
        '&.Mui-disabled': {
            color: '#bdbdbd !important',
        },
        '&.Mui-checked.Mui-disabled': {
            color: '#bdbdbd !important',
        },
    },
    checked: {},
});

const Divider = styled(MuiDivider)(spacing);

const Bold = (props) => <Box component={'span'} fontWeight="fontWeightBold" {...props}></Box>

export const GenericSidePanel = (props) => {

    const checkBoxClasses = [
        useCheckBoxStyles({color: "#C71585"}),
        useCheckBoxStyles({color: "purple"}),
        useCheckBoxStyles({color: "darkblue"}),
        useCheckBoxStyles({color: "skyblue"}),
        useCheckBoxStyles({color: "#0D98BA"}),
        useCheckBoxStyles({color: "seagreen"}),
        useCheckBoxStyles({color: "#9ACD32"}),
        useCheckBoxStyles({color: "#FFCC00"}),
        useCheckBoxStyles({color: "orange"}),
        useCheckBoxStyles({color: "#FF5349"}),
        useCheckBoxStyles({color: "red"}),
    ]

    const defaultCheckBoxClasses = useCheckBoxStyles({color: "#233044"})

    let {
        visible = [],
        data = [],
        onCheckCallbacks = [],
        headers = [],
        colourize = [],
        actions = [],
        actionsData = [],
        actionsCallbacks = [],
        footers = [],
        footersData = [],
        footersCallbacks = [],
        singleSelectIndices = [],
        defaultCheckIndices = [],
        stateCallbacks = [],
        timePeriodsReset = false,
        disabledItems = [],
        labelFormatters = [],
        initialCheckboxStates = [],
    } = props;

    // Memoize the filtered data to prevent prop mutation and unnecessary re-renders
    const filteredData = useMemo(() => {
        return data.map((list) =>
            list.filter(item => !(item.length === 4 && item.startsWith("(") && item.endsWith(")")))
        );
    }, [data]);

    const [checkboxStates, setCheckboxStates] = useState([])

    useEffect(() => {
        //Filling empties
        if(visible.length === 0)
            visible = new Array(filteredData.length).fill( true)
        if(onCheckCallbacks.length === 0)
            onCheckCallbacks = new Array(filteredData.length).fill( () => {})
        if(headers.length === 0)
            headers = new Array(filteredData.length).fill("")
        if(colourize.length === 0)
            colourize = new Array(filteredData.length).fill(false);
        if(footers.length === 0)
            footers = new Array(filteredData.length).fill(undefined);
        if(defaultCheckIndices.length === 0)
            defaultCheckIndices = new Array(filteredData.length).fill(0);
        if(singleSelectIndices.length === 0)
            singleSelectIndices = new Array(filteredData.length).fill(undefined)
        if(disabledItems.length === 0)
            disabledItems = new Array(filteredData.length).fill([]);
        if(labelFormatters.length === 0)
            labelFormatters = new Array(filteredData.length).fill(undefined);

        // Helper to strip non-checkbox headers (e.g., MODULE:) for competencies selection
        const filterListForState = (list) => list.filter(item => !item.startsWith('MODULE:'));

        const stateList = []
        let shouldUpdateState = false;

        if(checkboxStates.length === 0) {
            filteredData.forEach((list, index) => {
                const filtered = filterListForState(list);
                // Use initialCheckboxStates if provided and not empty, otherwise use defaultCheckIndices
                if (initialCheckboxStates[index] && Object.keys(initialCheckboxStates[index]).length > 0) {
                    // Merge initialCheckboxStates with filtered items to ensure all items have a state
                    const mergedState = {};
                    filtered.forEach((title, subIndex) => {
                        // Use initial state if available, otherwise default based on defaultCheckIndices
                        if (title in initialCheckboxStates[index]) {
                            mergedState[title] = initialCheckboxStates[index][title];
                        } else {
                            mergedState[title] = subIndex === defaultCheckIndices[index];
                        }
                    });
                    stateList.push(mergedState);
                } else {
                    stateList.push(Object.fromEntries(filtered.map((title, subIndex) => subIndex == defaultCheckIndices[index] ? [title, true] : [title, false])))
                }
            })
            shouldUpdateState = true;
        }
        else {
            filteredData.forEach((list, index) => {
                const filtered = filterListForState(list);
                //Checking if the list was altered
                let is_exact = true;
                // Check if checkboxStates[index] exists before calling Object.keys
                const previous_list = checkboxStates[index] ? Object.keys(checkboxStates[index]) : [];

                // Check if lists are identical
                if (filtered.length !== previous_list.length) {
                    is_exact = false;
                } else {
                    filtered.forEach((title) => {
                        if(!previous_list.includes(title)) {
                            is_exact = false;
                        }
                    })
                }

                //If the list is same as previous one, restore previous checkbox state
                if(is_exact && checkboxStates[index]) {
                    // If initialCheckboxStates is provided and different, use it
                    const hasInitialState = initialCheckboxStates[index] && Object.keys(initialCheckboxStates[index]).length > 0;
                    const isDifferent = hasInitialState && checkboxStates[index] &&
                        JSON.stringify(initialCheckboxStates[index]) !== JSON.stringify(checkboxStates[index]);

                    if (isDifferent) {
                        // Merge initialCheckboxStates with filtered items
                        const mergedState = {};
                        filtered.forEach((title) => {
                            if (title in initialCheckboxStates[index]) {
                                mergedState[title] = initialCheckboxStates[index][title];
                            } else {
                                mergedState[title] = checkboxStates[index][title] || false;
                            }
                        });
                        stateList.push(mergedState);
                        shouldUpdateState = true;
                    } else {
                        stateList.push(checkboxStates[index]);
                    }
                }
                //If the list has been changed or checkboxStates[index] doesn't exist, re-initialize state to default
                else {
                    if (initialCheckboxStates[index] && Object.keys(initialCheckboxStates[index]).length > 0) {
                        // Merge initialCheckboxStates with filtered items
                        const mergedState = {};
                        filtered.forEach((title, subIndex) => {
                            if (title in initialCheckboxStates[index]) {
                                mergedState[title] = initialCheckboxStates[index][title];
                            } else {
                                mergedState[title] = subIndex === defaultCheckIndices[index];
                            }
                        });
                        stateList.push(mergedState);
                    } else {
                        stateList.push(Object.fromEntries(filtered.map((title, subIndex) => subIndex == defaultCheckIndices[index] ? [title, true] : [title, false])))
                    }
                    shouldUpdateState = true;
                }
            })
        }

        // Only update state if there's an actual change
        if (shouldUpdateState) {
            setCheckboxStates([...stateList]);
        }


    }, [filteredData, initialCheckboxStates])

    useEffect(() => {
        stateCallbacks.forEach((stateObject, index) => {
            if(stateObject)
            {
                const {state, setState} = stateObject;
                if(state && setState)
                {
                    setSinglePanelState(index, state)
                    setState(undefined);
                }
            }
        })
    }, [stateCallbacks])

    useEffect(() => {
        if (timePeriodsReset) {
            const updatedStates = [...checkboxStates];
            const index = props.index ? props.index : 0;
            updatedStates[index] = Object.fromEntries(filteredData[index].map((title, subIndex) =>
                subIndex === defaultCheckIndices[index] ? [title, true] : [title, false]
            ));

            setCheckboxStates(updatedStates);

            if (typeof props.onResetAcknowledged === 'function') {
                props.onResetAcknowledged();
            }
        }
    }, [timePeriodsReset, filteredData, defaultCheckIndices, props]);

    const singlePanelState = (index) => {
        return checkboxStates[index]
    }

    const setSinglePanelState = (index, state) => {
        const local_copy = [...checkboxStates];
        local_copy.splice(index, 1, state)
        setCheckboxStates(local_copy);
    }

    const handleCheckboxChange = (event, index) =>
    {
        const singleState = singlePanelState(index);
        setSinglePanelState(index, { ...singleState, [event.target.name]: event.target.checked });
        if(singleSelectIndices[index] !== undefined) //Single selection should override all other selections or not
        {
            if(event.target.checked)
            {
                if(filteredData[index].indexOf(event.target.name) === singleSelectIndices[index]) {
                    setSinglePanelState(index, Object.fromEntries(filteredData[index].map(
                        (item, subIndex) => subIndex === singleSelectIndices[index] ? [item, true] : [item, false]
                    )));
                }
                else
                {
                    const single_select_element = filteredData[index][singleSelectIndices[index]]
                    setSinglePanelState(index, {
                        ...singleState,
                        [single_select_element]: false,
                        [event.target.name]: event.target.checked,
                    })
                }
            }
        }
        if(onCheckCallbacks[index])
        {
            onCheckCallbacks[index](event.target.name, event.target.checked, singleState, (state) => setSinglePanelState(index, state), setCheckboxStates)
        }
    }

    const handleFooterCallback = (event, callback, index) => {
        callback(event, singlePanelState(index), (state) => setSinglePanelState(index, state));
    }

    const handleActionButton = (value, index) => {
        actionsCallbacks[index](value, singlePanelState(index), (state) => setSinglePanelState(index, state));
    }

    function anyIndexVisible(min_index, max_index) {
        for(let i = min_index; i <= max_index; i++)
        {
            if(visible[i] !== false) return true;
        }
        return false;
    }

    return checkboxStates.length > 0 ?
    <ColouredCard>
        <CardContent id={"SidePanelContainer"} style={{alignItems: "center"}}>
            {data.map((list, index) => {
                const Action = actions[index];
                const Footer = footers[index];
                return visible[index] !== false ? <div className={`Panel ${index}`} key={`panel-${index}`}>
                    {
                        index !== 0 && anyIndexVisible(0, index-1) ?
                            <Divider mt={5} mb={5}/>
                        : null
                    }
                    <ColouredTypography mb={3} variant="body1" align={"center"}>
                        <Bold>
                            {headers[index]}
                        </Bold>
                    </ColouredTypography>
                    {
                        list.map(
                            (title, subIndex) => {
                                // Render module headers for competencies
                                if (title.startsWith('MODULE:')) {
                                    const moduleName = title.replace('MODULE:', '');
                                    return (
                                        <Box key={`module-${index}-${subIndex}-${title}`} mt={subIndex > 0 ? 2 : 0} mb={1}>
                                            <ColouredTypography variant="body1" style={{ fontWeight: 'bold', fontSize: '16px' }}>
                                                {moduleName}
                                            </ColouredTypography>
                                        </Box>
                                    );
                                }

                                const isDisabled = disabledItems[index]?.includes(title);
                                const displayLabel = labelFormatters[index] ? labelFormatters[index](title) : title;
                                return <Grid container justify="space-between" alignItems={"center"} key={`item-${index}-${title}`}>
                                    <Grid item xs={Action ? 10 : 12}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    className={colourize[index] ? checkBoxClasses[subIndex].root : defaultCheckBoxClasses.root}
                                                    name={title}
                                                    checked={checkboxStates[index][title] || false}
                                                    onChange={(event) => handleCheckboxChange(event, index)}
                                                    disabled={isDisabled}
                                                />
                                            }
                                            label={displayLabel}
                                        />
                                    </Grid>
                                    {
                                        Action ?
                                            <Grid item xs={2}>
                                                <Action {...actionsData[index]} value={title} onClick={() => handleActionButton(title, index)}></Action>
                                            </Grid>
                                            : null
                                    }
                                </Grid>
                            }
                        )
                    }
                    {
                        Footer ?
                            // <Footer {...footersData[index]} onChange={(event) => handleFooterChange(event, index)}/>
                            <Footer
                                {...footersData[index]}
                                {
                                    ...Object.fromEntries(
                                        Object.entries(footersCallbacks[index]).map(([property, callback]) =>
                                            [property, (event) => handleFooterCallback(event, callback, index)]
                                        )
                                    )
                                }
                            />
                            : null
                    }
                </div> : null
            })}
        </CardContent>
    </ColouredCard>
    : <></>;
}
